module.exports = __webpack_public_path__ + "static/media/occasions-service-guarantee.85a06aa6.jpg";